import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ReactComponent as ArrowForwardIcon } from 'assets/icons/arrow.svg';
import MilestoneCard from './MilestoneCard';
import MilestonesProgressBar from './MilestonesProgressBar';
import MilestoneDetails from 'modules/lc/timeline/MilestoneDetails';

const useStyles = makeStyles((theme) => ({
  nav: {
    'display': 'flex',
    '& button': {
      width: 48,
      height: 48,
      minWidth: 48,
    },
  },
  arrowIconForward: {
    '& path': {
      fill: '#FFF',
    },
  },
  arrowIconReverse: {
    'transform': 'rotate(180deg)',
    '& path': {
      fill: theme.palette.primary.main,
    },
  },
}));

const Carousel = ({
  milestones,
  user,
  student,
  totalMilestones,
  doneMilestones,
  setCurrentIndex,
  currentIndex,
}) => {
  const classes = useStyles();
  const [selected, setSelected] = useState();
  const userId = student.user_id;

  useEffect(() => {
    const nextInprogress = milestones.find((i) => i.status === 'inprogress');
    const nextNotStarted = milestones.find((i) => i.status === null);
    if (nextInprogress) {
      setCurrentIndex(milestones.indexOf(nextInprogress));
    }
    else if(nextNotStarted) {
      setCurrentIndex(milestones.indexOf(nextNotStarted));
    }
  }, []);

  useEffect(() => {
    requestAnimationFrame(() => {
      document
        .getElementById('scroll-container')
        .scroll({ top: 0, left: 0, behaviour: 'smooth' });
    });
  }, [currentIndex]);

  const onNext = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const onPrev = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === milestones.length - 1;

  const prevMilestone = milestones[currentIndex - 1];
  const nextMilestone = milestones[currentIndex + 1];

  if (milestones.length)
    return (
      <Box>
        <MilestonesProgressBar
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          totalMilestones={totalMilestones}
          doneMilestones={doneMilestones}
          milestones={milestones}
        />
        <Box marginBottom={3}>
          <MilestoneCard
            milestone={milestones[currentIndex]}
            user={user}
            student={student}
            onClick={setSelected}
            currentIndex={currentIndex}
          />
        </Box>
        <Box display="flex" justifyContent="space-between">
          {!isFirst && (
            <Box className={classes.nav}>
              <Button
                variant="outlined"
                color="primary"
                onClick={onPrev}
                disabled={isFirst}
              >
                <ArrowForwardIcon className={classes.arrowIconReverse} />
              </Button>
              <Box marginLeft={3}>
                <Typography variant="body2">Previous</Typography>
                <Typography>{prevMilestone?.name}</Typography>
              </Box>
            </Box>
          )}
          {!isLast && (
            <Box className={classes.nav} marginLeft="auto">
              <Box marginRight={3} textAlign="right">
                <Typography variant="body2">Next</Typography>
                <Typography>{nextMilestone?.name}</Typography>
              </Box>
              <Button
                variant="contained"
                color="primary"
                onClick={onNext}
                disabled={isLast}
              >
                <ArrowForwardIcon className={classes.arrowIconForward} />
              </Button>
            </Box>
          )}
        </Box>
        {selected && (
          <MilestoneDetails
            onClose={() => setSelected()}
            milestone={selected}
            studentId={userId}
            student={student}
            user={user}
          />
        )}
      </Box>
    );
  return null;
};

export default Carousel;
